import styles from "./styles.module.scss";
import { FC, Props } from "./typings";

import BackIcon from "assets/icons/back.svg?react";
import ArrowLeftIcon from "assets/icons/arrow_l.svg?react";
import HollowButton from "components/HollowButton";
import classNames from "classnames";
import { TwoFactorMethod } from "dto/Settings/TwoFactorMethod";
import { useTranslation } from "react-i18next";

const WebauthnMethod: FC<Props> = ({
  isActive,
  onCanceled,
  handleRemove,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapper}>
      <div className={styles.pathBar}>
        <div className={styles.backButton}>
          <BackIcon onClick={onCanceled}></BackIcon>
        </div>
        {t("settings.security.2faHeader")} <ArrowLeftIcon></ArrowLeftIcon>{" "}
        {t("settings.webauthnBreadcrumbTitle")}
      </div>

      {isActive && (
        <>
          <div className={styles.hint}>
            {t("settings.webauthnConfigured")}
            <br></br>
            {t("settings.webauthnResetRequiredNoDot")}
          </div>
        </>
      )}

      {!isActive && (
        <>
          <div className={styles.hint}>
            {t("settings.webauthnFollowInstructions")}
          </div>
        </>
      )}

      <div className={styles.buttons}>
        {isActive && (
          <div className={styles.disconnect}>
            <a onClick={() => handleRemove(TwoFactorMethod.WebAuthn)}>
              {t("settings.removeMethod")}
            </a>
          </div>
        )}
        <HollowButton text={t("common.cancel")} onClick={onCanceled}></HollowButton>
      </div>
      <div className={classNames(styles.hint, styles.disconnect)}></div>
    </div>
  );
};

export default WebauthnMethod;
